import {combineReducers} from '@reduxjs/toolkit'
import {authenticationReducer} from './common/auth/authenticationSlice'
import {notificationsReducer} from './common/notifications/notificationsSlice'

export const rootReducer = combineReducers({
  notifications: notificationsReducer,
  authentication: authenticationReducer,
})
export type RootState = ReturnType<typeof rootReducer>
